import {Injectable} from '@angular/core';
import {Emi, EmiSchedule} from '../model/emi-schedule.model';
import * as lodash from 'lodash';
import * as moment from 'moment-timezone';
import {EmiStatus} from '../model/emi-status';

@Injectable()
export class EmiUtil {
    public getFirstEmiDate(disbursalDate: Date = moment().toDate()): Date {
        const currentDate = moment(disbursalDate);
        if (currentDate.date() <= 15) {
            return moment(disbursalDate).add(1, 'month').date(5).endOf('day').toDate();
        } else {
            return moment(disbursalDate).add(2, 'months').date(5).endOf('day').toDate();
        }
    }

    public findNextEmi(schedule: EmiSchedule, referenceDate: Date): Emi {
        const futureEmis = lodash.filter(schedule, s => moment(s.due_on).isAfter(referenceDate));
        const nextEmi = Emi.from(lodash.minBy(futureEmis, 'due_on'));
        return nextEmi ? nextEmi : null;
    }

    public isEmiPaid(emi: Emi): boolean {
        return emi.status === EmiStatus.Received || emi.status === EmiStatus.Completed;
    }
}
